module.exports = __webpack_public_path__ + "static/img/bg-es.5d3ec7b9.png";